import { render, staticRenderFns } from "./News1.vue?vue&type=template&id=da59fb60"
import script from "./News1.vue?vue&type=script&lang=ts"
export * from "./News1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports